import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;

export default function CreateClass() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [scheduledAt, setScheduledAt] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
const [zoomLink, setZoomLink] = useState(""); //  Add state
  const [price, setPrice] = useState(""); //  New field


  const navigate = useNavigate();

  useEffect(() => {
    const teacher = JSON.parse(localStorage.getItem("user"));
    if (!teacher || teacher.role !== "teacher") {
      navigate("/login"); // Redirect if not a teacher
    }





     // ✅ Fetch teacher profile to get hourly_rate
  fetch( `${API_URL}/api/teachers/${teacher._id}`)
    .then((res) => res.json())
    .then((data) => {
      if (data?.hourly_rate) {
        setPrice(data.hourly_rate);
      }
    })
    .catch((err) => {
      console.error("Failed to load teacher profile:", err);
    });
  }, [navigate]);









  const handleCreate = async () => {
    const teacher = JSON.parse(localStorage.getItem("user"));

    if (!teacher || !teacher.id) {
      console.log(teacher);
      console.log(teacher.id)
      return setError("❌ Please log in as a teacher to create a class.");
    }

    if (!title || !scheduledAt) {
      return setError("❌ Title and schedule date/time are required.");
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await fetch(`${API_URL}/api/teacher/create-class`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title,
          description,
          teacherId: teacher.id,
          scheduledAt,
            zoomLink,
            price,
        }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "❌ Failed to create class.");

      setSuccess(`✅ Class "${data.title}" created! Join Code: ${data.code}`);
      setTitle("");
      setDescription("");
      setScheduledAt("");
      setPrice("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };



//const teacher = JSON.parse(localStorage.getItem("user"));

const connectZoom = () => {
 const clientId = process.env.REACT_APP_ZOOM_CLIENT_ID;

  const redirectUri =  `${API_URL}/api/zoom/oauth/callback`;

  if (!clientId) {
    alert("Zoom Client ID is missing");
    return;
  }

  const zoomUrl = `https://zoom.us/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`;
  window.location.href = zoomUrl;
};


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-blue-50 via-white to-blue-100 p-4">
      <div className="bg-white rounded-xl shadow-xl p-6 sm:p-10 max-w-xl w-full">
        <button
  className="bg-blue-600 text-white px-4 py-2 rounded"
  onClick={connectZoom}
>
  Connect Zoom
</button>
        <h1 className="text-3xl font-bold mb-6 text-blue-700 text-center">🎓 Create a Live Class</h1>

        {error && <p className="text-red-600 mb-4 text-center">{error}</p>}
        {success && <p className="text-green-600 mb-4 text-center">{success}</p>}

        <label className="block mb-2 text-sm font-semibold">Class Title</label>
        <input
          type="text"
          placeholder="Enter class title"
          className="border border-gray-300 p-2 mb-4 rounded w-full focus:outline-blue-400"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <label className="block mb-2 text-sm font-semibold">Description</label>
        <textarea
          placeholder="Optional class description..."
          className="border border-gray-300 p-2 mb-4 rounded w-full h-24 focus:outline-blue-400"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <label className="block mb-2 text-sm font-semibold">Schedule Date & Time</label>
        <input
          type="datetime-local"
          className="border border-gray-300 p-2 mb-6 rounded w-full focus:outline-blue-400"
          value={scheduledAt}
          onChange={(e) => setScheduledAt(e.target.value)}
        />

<label className="block mb-2 text-sm font-semibold">Zoom Link</label>
<input
  type="url"
  placeholder="https://zoom.us/..."
  className="border border-gray-300 p-2 mb-4 rounded w-full focus:outline-blue-400"
  value={zoomLink}
  onChange={(e) => setZoomLink(e.target.value)}
/>

<input
        type="number"
        min="0"
        step="0.01"
        placeholder="e.g. 9.99"
        className="border border-gray-300 p-2 mb-4 rounded w-full focus:outline-blue-400"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
      />
        <button
          onClick={handleCreate}
          disabled={loading}
          className={`w-full py-2 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700 transition ${
            loading ? "opacity-60 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Creating..." : "➕ Create Class"}
        </button>
      </div>
    </div>
  );
}
